export default __webpack_public_path__ + "static/media/BhadraWildlifesanctury.460bd93d.jpg";